import label from './pictorialBar.data.emphasis.label'
import itemStyle from './pictorialBar.data.emphasis.itemStyle'

export default {
  name: "emphasis",
  nickname: "高亮",
  desc: "emphasis",
  type: "object",
  props: {
    label,
    itemStyle,
  },
}
